import React, { Component } from 'react';

import './TimelineButton.scss';

import {
    DelayLink
} from '../components/';

import {
    Actions
} from '../flux/';

import {
    images
} from '../settings/';

import {
    PositionCalculator
} from '../utils/';

class TimelineButton extends Component {

	constructor() {
        super();

        this.images = images;

        this.calculator = PositionCalculator;

        this.runTransition = this.runTransition.bind(this);
	}

    componentDidMount() {
    }

    componentWillUnount() {
    }

    runTransition() {
        console.log('runTransition');
        Actions.globalTransition();
    }

	render() {
        const { className, x, y, onClick, url } = this.props;

        let buttonClasses = [
            'timeline_button',
            className
        ];

        let newX = this.calculator.proportionalWidth(x);
        let newY = this.calculator.proportionalHeight(y);

        let buttonStyle = {
            left: newX + 'px',
            top: newY + 'px'
        };

        const htmlRender = (url) ?
                                    <div onClick={ this.runTransition }>
                                        <DelayLink to={ url } delay={1000} className={ buttonClasses.join(' ') } style={ buttonStyle }>
                                            <div className="more_btn">
                                                <img src={ this.images.more_icon } />
                                            </div>
                                        </DelayLink>
                                    </div>
                                 :
                                    <div className={ buttonClasses.join(' ') } style={ buttonStyle } onClick={ onClick }>
                                        <div className="more_btn">
                                            <img src={ this.images.more_icon } />
                                        </div>
                                    </div>; 

        return (
            <div> { htmlRender }</div>
    	);
	}
}

export { TimelineButton };